export default [
    {
        value: "PR1",
        text: "PR1 - Redução de Homem-Hora "
    },
    {
        value: "PR2",
        text: "PR2 - Redução de Insumos"
    },
    {
        value: "PR3",
        text: "PR3 - Redução de Tempo"
    },
    {
        value: "PRX",
        text: "PRX - Outro Produtividade"
    },
    {
        value: "QF1",
        text: "QF1 - Redução de DEC, FEC e TMA"
    },
    {
        value: "QF2",
        text: "QF2 - Redução de VTCDs e Outros distúrbios"
    },
    {
        value: "QF3",
        text: "QF3 - Redução do Índice de Reclamações"
    },
    {
        value: "QFX",
        text: "QFX - Outro Qualidade do Fornecimento"
    },
    {
        value: "GA1",
        text: "GA1 - Postergação de Investimento"
    },
    {
        value: "GA2",
        text: "GA2 - Investimento Evitado"
    },
    {
        value: "GA3",
        text: "GA3 - Redução de Roubos e Furtos"
    },
    {
        value: "GAX",
        text: "GAX - Outro Gestão de Ativos"
    },
    {
        value: "NT1",
        text: "NT1 - Redução de Inadimplência"
    },
    {
        value: "NT2",
        text: "NT2 - Redução de Fraudes e Desvios"
    },
    {
        value: "NT3",
        text: "NT3 - Redução de Erros de Medição"
    },
    {
        value: "NT4",
        text: "NT4 - Redução de Perdas Indenizatórias"
    },
    {
        value: "NTX",
        text: "NTX - Outras Perdas Não-Técnicas"
    },
    {
        value: "ME1",
        text: "ME1 - Redução no Custo da Energia"
    },
    {
        value: "ME2",
        text: "ME2 - Redução nos Erros de Previsão"
    },
    {
        value: "MEX",
        text: "MEX - Outro Mercado da Empresa"
    },
    {
        value: "EE1",
        text: "EE1 - Aumento da Demanda Disponível (Oferta)"
    },
    {
        value: "EE2",
        text: "EE2 - Aumento da Energia Disponível (Oferta)"
    },
    {
        value: "EE3",
        text: "EE3 - Redução de Demanda (Uso Final)"
    },
    {
        value: "EE4",
        text: "EE4 - Energia Ecnomizada (Uso Final)"
    },
    {
        value: "EEX",
        text: "EEX - Outro Eficiência Energética"
    },
    {
        value: "OU",
        text: "OU - Outro"
    },
]